import { render, staticRenderFns } from "./HealthCareCases.vue?vue&type=template&id=2d3d4f2e&"
import script from "./HealthCareCases.vue?vue&type=script&lang=js&"
export * from "./HealthCareCases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports